export default {"src":"/_next/static/media/contains-nuts.24ac7e8d.svg","height":16,"width":16};